import React, { Component, PropTypes, useState } from 'react';
import { useLocation } from 'react-router-dom';
// import MultiStep from 'react-multistep';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import  './index.css';
import classNames from 'classnames';

const MultiStep = ({current}) => {
  return <>
    <div className="steps-form">
      <div className="steps-row setup-panel">
        <div className="steps-step">
          <a href="#" type="button" onClick={(e) => {e.preventDefault()}}
            className={classNames("btn  btn-circle", {'btn-indigo': current === 1, 'btn-default': current < 1, 'btn-success': current > 1})}>1</a>
        </div>
        <div className="steps-step">
          <a href="#" type="button" onClick={(e) => {e.preventDefault()}}
            className={classNames("btn  btn-circle", {'btn-indigo': current === 2, 'btn-default': current < 2, 'btn-success': current > 2})} >2</a>
        </div>
        <div className="steps-step">
          <a href="#" type="button" onClick={(e) => {e.preventDefault()}}
            className={classNames("btn  btn-circle", {'btn-indigo': current === 3, 'btn-default': current < 3, 'btn-success': current > 3})} >3</a>
        </div>
        {/*<div className="steps-step">
          <a href="#" type="button" onClick={(e) => {e.preventDefault()}}
            className={classNames("btn  btn-circle", {'btn-indigo': current === 4, 'btn-default': current < 4, 'btn-success': current > 4})} >4</a>
        </div>*/}
      </div>
    </div>
    </>
}


function Signup (props) {
    // const { onSubmit } = props
    const [step, setStep] = useState(1);
    const [picture, setPicture] = useState(null);
    const location = useLocation();

    const planNo = location.state?.plan ?? 1;
    const steps = [
      {name: 'StepOne', component: <React.Fragment />},
      {name: 'StepTwo', component: <React.Fragment/>},
      {name: 'StepThree', component: <React.Fragment/>},
      
    ];

    const prevStyle = {'background': '#33c3f0', color: '#fff'}
    const nextStyle = {'background': '#33c3f0', color: '#fff'}

    return (
    <React.Fragment>
        <div className="body_wrap">
            <div className="multi_form">
              <div className="navigation">
              {step === 4 ?
                <div className="step_five-heading"> 
                  <h2>Almost Done!</h2>
                  <p>Please confirm your package in order to complete your profile.</p>
                </div> : <React.Fragment>
                  <MultiStep current={step}/>
                </React.Fragment>
              }
              </div>
                {(step === 1) && <StepOne setPage={(_step) => {setStep(_step)}} />}
                {(step === 2) && <StepTwo setPage={(_step) => {setStep(_step)}} />}
                {(step === 3) && <StepThree setPage={(_step) => {setStep(_step)}}
                                            planId= {planNo}
                                            setPic={pic=> setPicture(pic)} submit={() => {
                                            console.log('submitting')
                }}/>}
                {/*{(step === 4) && <StepFour setPage={(_step) => {setStep(_step)}} picture ={picture} 
                  submit={() => {
                  console.log('submitting')
                }}/>}*/}
            </div>
        </div>
    </React.Fragment>

    );
}


export default Signup;



